// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-card {\n  padding: 20px;\n  margin: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
